<template>
  <Content :title="$t('ADVERTISEMENT.MAIL_SERVICE')">
    <Card class="mail-service-empty">
      <div class="mail-service-empty__content">
        <img src="~@/assets/images/mail.svg" />
        <p class="mail-service-empty__description">
          {{ $t('ADVERTISEMENT.MAIL_SERVICE.DESCRIPTON') }}
        </p>
        <ElButton type="primary" @click="emitNewMail">
          {{ $t('ADVERTISEMENT.MAIL_SERVICE.NEW_NOTIFICATION_BUTTON') }}
        </ElButton>
      </div>
    </Card>
  </Content>
</template>

<script>
import Card from '@@/common/Card';
import Content from '@@/common/layout/Content';

export default {
  name: 'MailServiceEmpty',
  components: {
    Card,
    Content,
  },
  methods: {
    emitNewMail() {
      this.$emit('newMail');
    },
  },
};
</script>

<style lang="scss">
.mail-service-empty {
  &__content {
    width: 100%;
    max-width: rem-calc(520px);
    min-height: rem-calc(580px);
    margin: auto;

    display: flex;
    flex-direction: column;

    justify-content: center;
    align-items: center;
  }

  &__description {
    text-align: center;

    margin-block: $global-margin * 1.5;
  }
}
</style>
